export const profile = {
  Name: "Abraham Bisrat",
  Titles: "Senior Software Engineer",
  Location: "Dallas TX",
};

export const avatar_src = "/images/avatar.jpg";

export const welcomePageTitles = [
  "Software Engineer",
  "Full Stack Developer",
  "Back End Developer",
];

export const linkedinUrl = "https://linkedin.com/in/abisrat";

export const githubUrl = "https://github.com/AbrahamBisrat";
